// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__E7i2M","checkboxCol":"Table_checkboxCol__4rtAy","emailCol":"Table_emailCol__3Nukd","actionCol":"Table_actionCol__3YEnZ"};